const common = {
    login: {
        /* 接口成功返回状态 */
        RESPONSE_STATUS: 200,
        /* 登录名 */
        username: ''
    },
    /* 系统信息 */
    systemInfo: {
        systemId: ''
    },
    /* mq类型 */
    mqType: {
        RABBITMQ: 0,
        ACTIVEMQ: 1
    },
    /* 资源运行状态 */
    resourceStatus: {
        using: 0,
        unUsing: 1
    },
    permissions: {},
    /* 插件运行状态 */
    pluginState: {
        UNLOADED: 0,
        LOADED: 1,
        STARTED: 2,
        STOPPED: 3,
        STARTFAILED: 4
    },
    /* 插件授权状态 */
    pluginAuthStatus: {
        NO_NEED: 0,
        AUTHORIZED: 1,
        UNAUTHORIZED: 2
    },
    /* 接口返回Ret信息  */
    requestCode: {
        SUCCESS_INFO_CODE: 'API-COMMON-INF-OK',
        UPLOAD_ROUTE_SETUP_FAIL_CODE: 'API-DEVICE-ERR-UPLOAD-ROUTER-FAIL',
        UPLOAD_DEVICE_SETUP_FAIL_CODE: 'API-DEVICE-ERR-SERVER-CONFIG-FAIL',
        ERROR_PASSWORD: 'API-AUTH-ERR-ERROR-PASSWORD'
    },
    // 任务运行状态
    jobRunState: {
        RUNNING: 'RUNNING',
        WAITTING: 'WAITTING',
        JOB_STATE_STOP: 'STOP',
        JOB_STATE_START: 'START'
    },

    /* 资源类型，0生产者，1消费者  */
    resType: {
        PRODUCER: 0,
        CONSUMER: 1
    },
    /* 报警管理--订阅分组维度 */
    groupDimension: {
        ALARM_ALL_MESSAGE: 0,
        ALARM_LEVEL: 1,
        ALARM_TYPE: 2,
        ALARM_EVENT_AND_DEVICE: 4,
        DEVICE_TYPE: 5
    },
    /* 报警管理--报警推送目的地 */
    pushDestination: {
        CLIENT: 1,
        THIRD_PARTY_SYSTEM: 2
    },
    /* 报警管理--报警推送方式 */
    pushWay: {
        WEB_SERVICE: 1
    },
    /* 报警订阅分组--全部报警事件默认id */
    subscribeEventAllId: '20194f71f4c044078c3742507f712282',
    /* mq队列/交换器类型定义 */
    mqChannelType: {
        MQCHANNELTYPE_QUEUE: 0, // mq通道类型-queue
        MQCHANNELTYPE_FANOUT: 1, // mq通道类型-fanout
        MQCHANNELTYPE_DIRECT: 2, // mq通道类型-direct
        MQCHANNELTYPE_TOPIC: 3 // mq通道类型-topic
    },
    /* 设备控制操作类型定义 */
    deviceOperateType: {
        DEVICE_OPERATE_TYPE_ALL: -1, // 全部
        DEVICE_OPERATE_TYPE_CONTROL: 0, // 控制
        DEVICE_OPERATE_TYPE_DOWNLOAD: 1, // 下载
        DEVICE_OPERATE_TYPE_QUERY: 2, // 查询
        DEVICE_OPERATE_TYPE_UPLOAD: 3, // 上传
        DEVICE_OPERATE_TYPE_CONFIG: 4 //配置
    },
    /* 设备控制类型定义 */
    deviceControlType: {
        CTL_MODE_TYPE_ALL: -1, // 全部
        CTL_MODE_SIMPLE: 0, // 同步简单
        CTL_MODE_DOUBLE_STREAM: 1, // 双向流
        CTL_MODE_SERVER_STREAM: 2, // 服务端流
        CTL_MODE_CLIENT_STREAM: 3 // 客户端流
    },
    devviceType: {
        MIDDEWARE: 3, // 中间件
        HOST: 4, // 视频主机
        CAMERA: 5, // 摄像机
        ADAPTER: 10001, // 适配器
        FILEADAPTER: 10002, //文件适配器
        FIIELSTORAGE: 10003, //文件存储服务器
        SMART_CLOUD: 10004, //智慧云
        ALARM_IN_OUT: 10005 //报警输入输出
    },
    /** 用户锁定状态 */
    userLockState: {
        LOCKED: '1',
        NOTLOCKED: '0'
    },
    /* 模板状态 */
    suspensionState: {
        RUN: '1',
        STOP: '2'
    },
    /** 初始化组织树所需参数 */
    initOrgTreeParam: {
        // 根据编号查询树形
        SCODE: ['BH-0001'],
        // 展示根节点ID
        PARENTORGID: [],
        // 树形节点类型
        ORGTYPEIDS: []
    },
    /** 初始化组织设备树参数 */
    initOrgDevTreeParam: {
        ROOT_PARENT_ID: '0001'
    },
    /* 菜单信息 */
    topMenuType: {
        menuId: '3000',
        menuName: '一级菜单'
    },
    /**上传方式 */
    uploadWay: {
        fileWay: 0,
        textWay: 1
    },
    /** 设备控制--mq订阅信息*/
    devCtrlSubscribe: {
        consumer: 'dev_ctrl_consumer',
        producer: 'dev_ctrl_producer'
    },
    /* top菜单map */
    topMenuIdMap: {},
    /**适配器信息 */
    adapterInfo: [],
    /** 组织相关树形默认根节点 */
    rootNode: [
        {
            caption: '组织管理',
            children: null,
            id: '21dsec1d-4a27-48d1-we4c5-e44fcc23110',
            noPermission: false,
            order: 1,
            parentId: '0001',
            parentName: null,
            sCode: 'BH-0001',
            sIcon: 'org',
            typeId: 0,
            typeName: '组织'
        }
    ],
    /** 设备状态--mq订阅信息*/
    devStatusSubscribe: {
        consumer: 'dev_status_consumer',
        producer: 'dev_status_producer'
    },
    /** 设备gps信息--mq订阅信息*/
    devGpsSubscribe: {
        consumer: 'dev_gps_consumer',
        producer: 'dev_gps_producer'
    },
    /** 状态推送消息类型*/
    statusDataType: {
        VS: 'vs',
        TV: 'tv',
        NVR: 'nvr'
    },
    /** 中间件推送消息类型*/
    middlewareType: {
        ONLINE_STATUS: 'onlineStatus',
        GPS: 'gps'
    },
    /** 前置排序和后序排序*/
    dragPosition: {
        BEFORE: 'before',
        AFTER: 'after'
    },
    /** 字段类型*/
    sFieldType: {
        sKeyField: '1',
        sValueField: '2',
        sDescField: '3'
    },
    /** 节点类型*/
    sType: {
        database: 'database',
        table: 'table'
    },
    /** 默认节点id*/
    defaultDatabase: {
        id: '63622e887dce45ef84a538647bb737f8'
    },

    /** 操作类型*/
    operateType: {
        DETAIL: 'detail',
        ADD: 'add',
        EDIT: 'edit'
    },

    /** 文件类型*/
    fileType: {
        PROPERTIES: 'properties',
        XML: 'xml',
        JSON: 'json',
        INI: 'ini'
    },

    /** 配置中心树形节点类型*/
    settingCenter: {
        module: 0,
        file: 1
    },

    // 设备状态
    devStatus: {
        ONLINE: '0',
        OFFLINE: '1'
    }
};
export default common;
